<template>
  <div class="winner-workflow">
    <div
      ref="public-searchForm"
      class="public-searchForm work-search"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="80px"
        size="small"
      >
        <el-form-item
          prop="apiName"
          label="名称"
        >
          <el-input
            v-model.trim="searchForm.apiName"
            clearable
            placeholder="名称"
          />
        </el-form-item>
        <el-form-item
          prop="apiCode"
          label="编码"
        >
          <el-input
            v-model.trim="searchForm.apiCode"
            clearable
            placeholder="编码"
          />
        </el-form-item>
        <el-form-item label-width="0">
          <div class="search-handler">
            <el-button
              icon="el-icon-refresh"
              @click="reset"
            >
              重置
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="loading.search"
              @click="search"
            >
              查询
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="public-table">
      <div class="public-table-top">
        <div class="table-title">
          HTTP API 列表
        </div>
        <div class="public-table-top-btn">
          <el-button
            type="primary"
            size="mini"
            @click="add"
          >
            新增
          </el-button>
        </div>
      </div>
      <el-table
        v-if="showTable"
        ref="tableData"
        :height="tableHeight"
        :data="tableData"
        border
      >
        <el-table-column
          v-for="item in tableCol"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :min-width="item.minWidth"
        />
        <el-table-column
          label="操作"
          width="100"
          fixed="right"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <a @click="update(scope.row)">修改</a>
            <el-popconfirm
              title="确定删除此项？"
              class="form-create-popconfirm"
              @confirm="del(scope.row)"
            >
              <a slot="reference">删除</a>
            </el-popconfirm>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      ref="public-pagination"
      class="public-pagination"
    >
      <WPagination
        v-model="page"
        @change="query"
      />
    </div>
    <add
      :is-open="isOpen"
      :value="rowValue"
      :is-edit="isEdit"
      @close="isOpen = false"
      @addSuccess="addSuccess"
    />
  </div>
</template>
<script>
import add from './add.vue'
import api from '@workflow/api/index.js'
import tableHeight from '@workflow/mixins/tableHeight.js'
export default {
  name: 'HttpApi',
  components: { add },
  mixins: [tableHeight],
  data() {
    const assignee = localStorage.employeeNo
    return {
      isOpen: false,
      isEdit: false,
      loading: {
        search: false
      },
      assignee,
      searchForm: {
        apiCode: '',
        apiName: '',
        id: ''
      },
      selectParam: {},
      page: {},
      tableData: [],
      tableCol: [
        { label: '名称', key: 'apiName', minWidth: 150 },
        { label: '编码', key: 'apiCode', minWidth: 150 },
        { label: '微服务名', key: 'microServicesName', minWidth: 100 },
        { label: '接口路径', key: 'url', minWidth: 250 },
        { label: '请求方式', key: 'requestType', minWidth: 100 },
        { label: '分类', key: 'type', minWidth: 120 }
      ],
      showTurnDialog: false,
      rowValue: {}
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    checkSearch() {
      const { total, size, current } = this.page
      if (current !== 1 && total > size && size * (current - 1) + 1 !== total) {
        this.reset()
      } else {
        this.query()
      }
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      this.query()
    },
    addSuccess() {
      this.isOpen = false
      this.query()
    },
    query() {
      this.loading.search = true
      const { current, size } = this.page
      api.httpApi.getHttpApiList({
        pageParam: { current, size },
        selectParam: this.selectParam
      }).then((data) => {
        this.tableData = data.records
        this.page.total = data.total
        if (!data.records.length) this.$message.warning('查无数据！')
      }).finally(() => {
        this.loading.search = false
      })
    },
    update(row) {
      this.isOpen = true
      this.isEdit = true
      this.rowValue = row
    },
    del(row) {
      api.httpApi.delHttpApli({ id: row.id }).then(() => {
        this.$message.success('删除成功！')
        this.checkSearch()
      })
    },
    add() {
      this.isOpen = true
      this.isEdit = false
    }
  }
}
</script>
